// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ElementType,
  HighlightType,
} from "./types";

export default {
  presenceId: __t.u64(),
  sessionId: __t.option(__t.u64()),
  get elementType() {
    return ElementType;
  },
  elementId: __t.string(),
  get highlightType() {
    return HighlightType;
  },
  color: __t.string(),
  pulse: __t.bool(),
  durationMs: __t.option(__t.u32()),
  message: __t.option(__t.string()),
  priority: __t.u8(),
};
